import { useSeatingState } from "@shared/modules/seating/contexts/useSeatingState";
import { SeatingRealtimeStatus } from "@shared/modules/seating/features/real-time-seating/components/SeatingRealtimeStatus.web";
import { useTranslation } from "@shared/utils/internationalization";
import Button from "@ui-kit/form/Button/Button.web";
import IconButton from "@ui-kit/form/IconButton/IconButton.web";
import Box from "@ui-kit/layout/Box/Box.web";
import VStack from "@ui-kit/layout/Stack/VStack.web";
import { MapButtonsProps } from "./MapButtons.props";

export default function MapButtons({
  centerStage,
  zoomIn,
  zoomOut,
  onLegendModalOpen,
  onToggleBestAvailableList,
  isBestAvailableListOpen,
}: MapButtonsProps) {
  const { t } = useTranslation("seating");

  const { disableBestAvailableSeating } = useSeatingState();

  return (
    <>
      <Box position="absolute" top="md" right="md" zIndex="seatingMap">
        <VStack gap="xs">
          <IconButton
            data-testid="center-map"
            borderWidth="0px"
            borderRadius="md"
            backgroundColor="primary.400"
            minWidth="element.2xl"
            height="element.2xl"
            _focus={{ boxShadow: "none" }}
            _hover={{ backgroundColor: "primary.500" }}
            aria-label={t("center the map")}
            onClick={centerStage}
            colorPalette="ghost"
            iconName="Home"
            iconColor="primary.900"
          />
          <IconButton
            data-testid="toggle-legend"
            borderWidth="0px"
            borderRadius="md"
            backgroundColor="primary.400"
            minWidth="element.2xl"
            height="element.2xl"
            _focus={{ boxShadow: "none" }}
            _hover={{ backgroundColor: "primary.500" }}
            aria-label={t("open the map's legend")}
            onClick={onLegendModalOpen}
            colorPalette="ghost"
            iconName="List"
            iconColor="primary.900"
          />
        </VStack>
      </Box>
      <Box position="absolute" top="7xl" right="md" zIndex="seatingMap">
        <VStack gap="xs">
          <IconButton
            data-testid="zoom-in"
            borderWidth="2px"
            borderColor="gray.600"
            borderRadius="md"
            backgroundColor="bg"
            minWidth="element.2xl"
            height="element.2xl"
            _focus={{ boxShadow: "none" }}
            _active={{ backgroundColor: "gray.300" }}
            _hover={{ backgroundColor: "gray.300" }}
            aria-label={t("zoom in")}
            onClick={zoomIn}
            colorPalette="ghost"
            iconName="Plus"
            iconColor="gray.600"
          />
          <IconButton
            data-testid="zoom-out"
            borderWidth="2px"
            borderColor="gray.600"
            borderRadius="md"
            backgroundColor="bg"
            minWidth="element.2xl"
            height="element.2xl"
            _focus={{ boxShadow: "none" }}
            _active={{ backgroundColor: "gray.300" }}
            _hover={{ backgroundColor: "gray.300" }}
            aria-label={t("zoom out")}
            onClick={zoomOut}
            colorPalette="ghost"
            iconName="Minus"
            iconColor="gray.600"
          />
        </VStack>
      </Box>
      {!disableBestAvailableSeating && onToggleBestAvailableList && (
        <Button.Outline
          data-testid="toggle-best-available-list"
          zIndex="seatingMap"
          position="absolute"
          borderRadius="md"
          borderWidth="2px"
          top="md"
          left="md"
          height="element.2xl"
          display={{ base: "block", sm: "none" }}
          aria-label={t("toggle the best available list")}
          onClick={onToggleBestAvailableList}
          fontSize="xs"
          backgroundColor="bg"
        >
          {isBestAvailableListOpen ? t("View map") : t("View list")}
        </Button.Outline>
      )}
      <SeatingRealtimeStatus />
    </>
  );
}
